export const QueryKeys = {
    GetAllBookings: 'get-all-bookings',
    Ahead: 'ahead-bookings',
    DetailBooking: 'detail-booking',
}
